import React from "react";
import "./css/LoadingScreen.css";

function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default LoadingScreen;
